import React from 'react'

import { useTranslation } from 'react-i18next'

import flagPl from './../img/flag_pl.jpg'
import flagEn from './../img/flag_en.jpg'
import flagRu from './../img/flag_ru.jpg'
import flagRo from './../img/flag_ro.jpg'

const LanguageSwitch = () => {

  const { t, i18n } = useTranslation()
  const lang = i18n.language

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
  }

  const Switch = ({code, name, flag}) => (
    <button onClick={() => changeLanguage(code)} className={`${code === lang && 'active'}`}>
      <img src={flag} alt={name} />
      <span>{name}</span>
    </button>
  )

  return (
    <div className="language-switch">
      <Switch
        code='pl'
        name={t('Polish')}
        flag={flagPl}
      />
      <Switch
        code='en'
        name={t('English')}
        flag={flagEn}
      />
      <Switch
        code='ru'
        name={t('Russian')}
        flag={flagRu}
      />
      <Switch
        code='ro'
        name={t('Romanian')}
        flag={flagRo}
      />
    </div>
  )
}

export default LanguageSwitch